export default __webpack_public_path__ + "static/media/software.e5320fa3.svg";